// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3d6526af","239":"856a7018","453":"ab22b1d5","455":"0663528e"}[chunkId] + ".chunk.js";
};